<template>
  <div class="b200">
      <div class="b202">
        <div :class="['b203','t3']" v-if="!isMobile">
          Web Development by: 
          <span :class="['btn','link1']" @click="openLink('https://rexrothdev.com')">Rexroth Development</span>
        </div>
        <div class="b204">
          <img class="logo2" src="/gallery/logo.jpg" />
          <div class="t1">Promise Land Community</div>
          
          <div class="b205" style="position: relative">            
            <img class="img5" src="/gallery/icons/facebook.png" @click="openLink('https://www.facebook.com/Promiselandcommunity1999')" />
            <img class="img5" src="/gallery/icons/instagram.png" />
            <a v-if="isMobile" href="tel:2602326440" target="_blank"><img class="img5" src="/gallery/icons/phone.png" /></a>            
            <img v-if="!isMobile" @click="callPhone" class="img5" src="/gallery/icons/phone.png" />
            <transition>
              <div style="width:200px; margin-left:calc(83.33% - 100px); text-align:center;  margin-top:4px; position:absolute;" v-if="showPhone" :class="['t3','tran1']" >260-232-6440</div>
            </transition>
          </div>
        </div>
        <div class="b2032" v-if="!isMobile">
          <div :class="['t3','btn','b206']" @click="dispatch('home','home')">Home</div>     
          <div :class="['t3','btn','b206']" @click="dispatch('resources','resources')">Resources</div>          
          <div :class="['t3','btn','b206']" @click="dispatch('about','about')">About</div>          
          <div :class="['t3','btn','b206']" @click="dispatch('events','events')">Events</div>          
        </div>
        <div :class="['b203','t3']" v-if="isMobile">
          Web Development by: 
          <span :class="['btn','link1']" @click="openLink('https://rexrothdev.com')">Rexroth Development</span>
        </div>
      </div>
      <p class="nonprofit">Promise Land Community Inc is a 501(c)(3)<br class="mobile-break"> Not-for-Profit Organization.</p>
    </div>
</template>

<script>
  export default {
    data() {
      return {
        // isMobile: false,
        showPhone: false,
      }
    },
    // computed: {
    //   showPhone() {
    //     return this.phone;
    //   }
    // },
    methods: {
      callPhone(){
          this.showPhone=true;
          window.setInterval(() => {
            this.showPhone=false;
          }, 7000);
      },
    },
    mounted() {
      if (!document.getElementById('ngo-jsonld')) {
        const script = document.createElement('script');
        script.id = 'ngo-jsonld';
        script.type = 'application/ld+json';
        script.textContent = JSON.stringify({
          "@context": "https://schema.org",
          "@type": "NGO",
          "name": "Promise Land Community Inc",
          "url": "https://promiselandcommunity.com",
          "description": "Promise Land Community Inc is a registered 501(c)(3) not-for-profit organization."
        });
        document.head.appendChild(script);
      }
    },
  }
</script>

<style scoped>
.b200 {
  width: 100%;
  background-color: v-bind(color2);
  display: flex;
  flex-direction: column;
  align-items: center;
}
.nonprofit {
  width: min(680px, 90%);
  text-align: center;
  color: rgba(255, 255, 255, 0.82);
  font-size: calc(0.3vw + 0.82rem);
  letter-spacing: 0.02em;
  line-height: 1.5;
  margin: 0;
  padding: 22px 12px;
  border-top: 1px solid rgba(255, 255, 255, 0.25);
}
.b201 {
  /* padding-top:40px;
  padding-bottom:40px;
  padding-left: v-bind(margin);
  padding-right: v-bind(margin); */
  padding: calc(v-bind(margin) * 2.5);
  text-align: center;
  color: v-bind(color3);
}
.b202 {
  display: flex;
  align-items: center;
  width: 100%;
  padding-top: 40px;
  padding-bottom: 40px;
}
.b203 {
  width: 20%;
  margin-left: 10%;
  display: flex;
  flex-direction: column;
  justify-content: center;
  color: white;
}
.b2032 {
  width: 20%;
  margin-left: 10%;
  display: flex;
  flex-direction: column;
  justify-content: space-evenly;
}
.b204 {
  color:v-bind(color1);
  width:40%;
  display:flex;
  flex-direction: column;
  justify-content: space-evenly;
  align-items: center;
}
.b206 {
  color:v-bind(color1);
  text-decoration: underline;
  border-bottom:1px;  
  text-underline-offset: 3px;
}

.btn:hover {
  cursor:pointer;
  color: v-bind(color4);  
  text-decoration:underline;
}

.img5 {
  height: calc(1.4 * 1vw + 1rem);  
  margin-left:20px;
  margin-right:20px;
  margin-top:30px;
}


.img5:hover {
  cursor:pointer;
  transform: scale(1.1);
}

.logo2 {
  height: calc(3 * 1vw + 1rem);
  margin-bottom:15px;
}
.tran1 {
  transition: all .5s ease;
}
.v-enter-from, .v-leave-to {
    opacity:0;    
}
.v-leave-from, .v-enter-to {
    opacity:1;
}
@media only screen and (min-width: 1153px) {
  .mobile-break { display: none; }
}
@media only screen and (max-width: 1152px) {
  .b202{
    display:block;
  }
  .b203 {
    width:100%;
    height:auto;
    margin:0;
    text-align:center;
    margin-top:30px;
  }
  .b204{
    width:100%;
  }
  .link1 {
    text-decoration:underline;
    border-bottom:1px;  
    text-underline-offset: 3px;
    text-decoration-thickness: 1px;
  }
  .logo2 {
    height: calc(3 * 4vw + 1rem);
    margin-bottom:15px;
  }
}
</style>